export default __webpack_public_path__ + "static/graphicTwoImg-188710c7c512231041ce1eaf4ab65b75.svg";